import { createFileRoute, redirect } from '@tanstack/react-router';
import { toast } from 'sonner';

import { AuthService } from '@/entities/auth/auth-service';
import { fetchUser } from '@/entities/auth/fetch-user';
import { buildLoginSearch } from '@/shared/redirect/build-login-search';
import z from 'zod';

const searchParams = z.object({
  token: z.string(),
});

export const Route = createFileRoute('/invite')({
  validateSearch: searchParams,
  beforeLoad: async (ctx) => {
    const { token } = ctx.search;

    if (token === undefined) {
      toast.error('Invalid invite token');
      throw redirect({ to: '/login', search: buildLoginSearch(ctx.location.searchStr) });
    }

    try {
      await fetchUser();
    } catch {
      toast('Login required');
      throw redirect({
        to: '/login',
        search: buildLoginSearch(ctx.location.searchStr, { token }),
      });
    }

    let id: string;
    try {
      const workspace = await AuthService.validateInviteToken(token);
      id = workspace.id;
    } catch (e) {
      console.error(e);
      toast.error('Invalid invite token');
      throw redirect({ to: '/login', search: buildLoginSearch(ctx.location.searchStr) });
    }
    throw redirect({
      to: '/workspace/$workspaceId',
      params: { workspaceId: id },
    });
  },
});
